import { RxFilePlus } from '@react-icons/all-files/rx/RxFilePlus'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import {
  AccessibleIcon,
  DropdownMenu,
  Flex as DsFlex,
  IconButton,
  Tooltip,
} from 'components/ds'
import { EllipsisVerticalIcon } from 'components/ui/icon/svg-icons'

import BriefProjectSettingsDialog from '../brief-project-settings-dialog'
import DeleteProjectDialog from '../delete-project-dialog'
import RenameProjectDialog from '../rename-project-dialog'
import mixpanelClient from '@disco/api/mixpanel'

interface BriefProjectActionsProps {
  briefProjectId?: string
}

const BriefProjectActions: React.FC<BriefProjectActionsProps> = ({
  briefProjectId,
}) => {
  const navigate = useNavigate()
  const [deleteProjectDialogOpen, setDeleteProjectDialogOpen] = useState(false)
  const [renameProjectDialogOpen, setRenameProjectDialogOpen] = useState(false)
  const [settingsDialogOpen, setSettingsDialogOpen] = useState(false)

  const handleCreateNewBrief = () => {
    if (briefProjectId) {
      mixpanelClient.sendPureEvent('Brief created', {Context: 'Briefs', source: 'project', project_id: briefProjectId})
      navigate(`/brief-editor/new?projectId=${briefProjectId}`)
    }
  }

  const handleRenameProject = () => {
    setRenameProjectDialogOpen(true)
  }

  const handleOpenSettings = () => {
    setSettingsDialogOpen(true)
  }

  if (!briefProjectId) {
    return null
  }

  return (
    <>
      <DsFlex align="center" justify="end" gap="2" pr="2">
        <Tooltip content="New brief">
          <IconButton
            variant="ghost"
            color="gray"
            size="2"
            onClick={handleCreateNewBrief}
          >
            <AccessibleIcon label="New Brief">
              <RxFilePlus size={24} />
            </AccessibleIcon>
          </IconButton>
        </Tooltip>
        <DropdownMenu.Root>
          <DropdownMenu.Trigger>
            <IconButton variant="ghost" color="gray" size="2">
              <AccessibleIcon label="Brief Project Actions">
                <EllipsisVerticalIcon size={24} />
              </AccessibleIcon>
            </IconButton>
          </DropdownMenu.Trigger>
          <DropdownMenu.Content variant="soft" align="end">
            <DropdownMenu.Item onClick={handleRenameProject}>
              Rename project
            </DropdownMenu.Item>
            <DropdownMenu.Item onClick={handleOpenSettings}>
              Project notes
            </DropdownMenu.Item>
            <DropdownMenu.Item
              color="red"
              onClick={() => setDeleteProjectDialogOpen(true)}
            >
              Delete project
            </DropdownMenu.Item>
          </DropdownMenu.Content>
        </DropdownMenu.Root>
      </DsFlex>
      {deleteProjectDialogOpen && (
        <DeleteProjectDialog
          onOpenChange={setDeleteProjectDialogOpen}
          briefProjectId={briefProjectId}
        />
      )}
      {renameProjectDialogOpen && (
        <RenameProjectDialog
          onOpenChange={setRenameProjectDialogOpen}
          briefProjectId={briefProjectId}
        />
      )}
      {settingsDialogOpen && (
        <BriefProjectSettingsDialog
          onOpenChange={setSettingsDialogOpen}
          briefProjectId={briefProjectId}
        />
      )}
    </>
  )
}

export default BriefProjectActions
